import {DataStore, Predicates} from '@aws-amplify/datastore';

import {SigninOption} from 'models';

import {I18n} from '@aws-amplify/core';

export const fetchRecords = async () => {
    try {
        return DataStore.query(SigninOption);
    } catch (e) {
        console.debug(e);
    }
};

export const fetch = async (recordId) => {
    return DataStore.query(SigninOption, recordId);
};

export const add = async (payload) => {
    await deleteAllRecords();

    I18n.setLanguage(payload.language);

    payload.createdAt = new Date().toISOString();
    return DataStore.save(new SigninOption({...payload}));
};

export const update = async (recordId, record) => {
    const original = await DataStore.query(SigninOption, recordId);

    const updated = SigninOption.copyOf(original, (updated) => {
        updated.language = record.language;
        updated.show_return_to = record.show_return_to;
        updated.max_return_to = record.max_return_to;
        updated.password_and_sso = record.password_and_sso;
        updated.updatedAt = new Date().toISOString();
    });

    I18n.setLanguage(record.language);

    return DataStore.save(updated);
};

export const deleteRecord = async (recordId) => {
    const original = await DataStore.query(SigninOption, recordId);
    return DataStore.delete(original);
};

export const deleteAllRecords = async () => {
    return DataStore.delete(SigninOption, Predicates.ALL);
};
